
















import Vue, { PropOptions } from 'vue';
interface LocalProps {
  target: PropOptions;
  placement: PropOptions;
}
export default Vue.extend({
  name: 'HMPopover',
  props: {
    target: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: 'rightbottom',
    },
    triggers: {
      type: String,
      default: 'hover focus',
    },
  } as LocalProps,
});
